import { render, staticRenderFns } from "./ContainerPrototypeItem.vue?vue&type=template&id=22e33760&scoped=true"
import script from "./ContainerPrototypeItem.vue?vue&type=script&lang=js"
export * from "./ContainerPrototypeItem.vue?vue&type=script&lang=js"
import style0 from "./ContainerPrototypeItem.vue?vue&type=style&index=0&id=22e33760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e33760",
  null
  
)

export default component.exports